// extracted by mini-css-extract-plugin
export default {"banner":"interview-progress-banner_banner__bDGiS"};